export default __webpack_public_path__ + "static/media/world_map_image_main.4294b0b1.png";